import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Card, CardBody } from 'reactstrap';
import CustomPagination from 'components/commons/CustomPagination';
import usePendingAction from '../hooks/usePendingAction';
import ModalUploadPOProof from '../modals/ModalUploadPOProof';
import ModalPreviewPOProof from '../modals/ModalPreviewPOProof';
import PoFilter from './PoFilter';
import PoTable from './PoTable';

/**
 * One list tab (PO List, Approval, Pencairan, Finalization, Edit Mutation
 * Date, History). Everything tab-specific comes from `tab` (see config.js);
 * the rows themselves live in redux and are fetched by the page.
 */
const PoListTab = ({
  tab,
  page,
  appliedFilter,
  onSearch,
  openDetail,
  refetch,
}) => {
  const history = useHistory();
  const { isFinanceDepartment } = useSelector((state) => state.auth);
  const rows = useSelector(({ purchaseOrder }) => purchaseOrder.PO);
  const count = useSelector(({ purchaseOrder }) => purchaseOrder.countPO);
  const status = useSelector(({ purchaseOrder }) => purchaseOrder.status);

  const [uploadTargetId, setUploadTargetId] = useState(null);
  const [previewPath, setPreviewPath] = useState(null);
  const { isPending, run } = usePendingAction();

  // Out-of-range or missing page → back to page 1.
  useEffect(() => {
    if (!page || (Math.ceil(count / 10) < page && count !== 0)) {
      history.push(`?page=1&tab=${tab.name}`);
    }
  }, [page, count, history, tab.name]);

  const ctx = {
    tab,
    isFinance: isFinanceDepartment,
    isPending,
    run,
    refetch,
    openDetail,
    openUpload: setUploadTargetId,
    onPreview: setPreviewPath,
  };

  return (
    <Card>
      <CardBody>
        <PoFilter tab={tab} applied={appliedFilter} onSearch={onSearch} />
        <CustomPagination
          className="mt-5"
          pages={Math.ceil(count / 10 || 1)}
          active={page}
        />
        <PoTable
          tab={tab}
          rows={rows}
          loading={status === 'loading'}
          ctx={ctx}
        />
      </CardBody>

      <ModalUploadPOProof
        isOpen={uploadTargetId !== null}
        toggle={() => setUploadTargetId(null)}
        activeId={uploadTargetId}
        onUploaded={refetch}
      />
      <ModalPreviewPOProof
        isOpen={previewPath !== null}
        toggle={() => setPreviewPath(null)}
        proofData={previewPath || ''}
      />
    </Card>
  );
};

export default PoListTab;
